import {fromJS, List, Map} from 'immutable';

import {
  LOAD_ALL_STATES_FULFILLED,
  LOAD_ALL_STATES_PENDING,
  LOAD_ALL_STATES_REJECTED,
  LOAD_STATE_MANDATE_FULFILLED,
  LOAD_STATE_MANDATE_PENDING,
  LOAD_STATE_MANDATE_REJECTED,
  SET_SELECTED_STATE,
} from '../../actions';

const initialState = new Map({
  loading: false,
  selectedState: 'PA',
  states: new List(),
  model: new Map({
    userState: '',
    careerPathway: '',
    mandate: '',
  }),
});

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_ALL_STATES_PENDING:
    case LOAD_STATE_MANDATE_PENDING:
      return state.set('loading', true);

    case LOAD_ALL_STATES_REJECTED:
    case LOAD_STATE_MANDATE_REJECTED:
      return state.set('loading', false);

    case LOAD_STATE_MANDATE_FULFILLED:
      return state.withMutations(map =>
        map.set('loading', false)
          .set('model', fromJS(action.payload.data))
      );

    case LOAD_ALL_STATES_FULFILLED:
      return state.withMutations(map =>
        map.set('loading', false)
          .set('states', fromJS(action.payload.data))
      );

    case SET_SELECTED_STATE:
      return state.set('selectedState', action.payload);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/stateMandates/reducers/pages/showStateMandate.js